/**
 * Created by Administrator on 2017-11-27.
 */
export function nomalTime(date) {
  if (String(date).indexOf('-') > -1) {
    return date
  }
  var time = new Date(date)
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate()
  var h = time.getHours()
  var mm = time.getMinutes()
  var s = time.getSeconds()
  if (String(y).indexOf('NaN') > -1) {
    return ''
  }
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s)
}

export function add0(m) {
  return m < 10 ? '0' + m : m
}

export function gelinToNomalTime(time) {
  return [time.getFullYear(), time.getMonth() + 1, time.getDate()].join('-')
}

/**
 * 时间格式化方法
 * @param time 时间戳
 * @param fmt 时间格式
 * @return 对于格式的时间
 */
export function format(time, fmt) {
  if (!time) return ''
  let f = fmt || 'yyyy-MM-dd'
  let date = new Date(time)
  let obj = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  if (/(y+)/.test(f)) {
    f = f.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length))
  }
  for (let k in obj) {
    if (new RegExp(`(${k})`).test(f)) {
      let s = `00${obj[k]}`
      f = f.replace(RegExp.$1, RegExp.$1.length === 1 ? obj[k] : s.substr(s.length - 2))
    }
  }
  return f
}

/*时间戳转化成多少天前*/
export function getDateDiff(dateTimeStamp) {
  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var month = day * 30;
  var year = month * 12;
  var now = new Date().getTime();
  var diffValue = now - dateTimeStamp;
  // console.log(dateTimeStamp)
  if (diffValue < 0) {
    return;
  }
  var yearC = diffValue / year;
  var monthC = diffValue / month;
  var dayC = diffValue / day;
  var hourC = diffValue / hour;
  var minC = diffValue / minute;
  var result;
  if (yearC >= 1) {
    result = "" + parseInt(yearC) + "年前";
  } else if (monthC >= 1) {
    result = "" + parseInt(monthC) + "月前";
  } else if (dayC >= 1) {
    result = "" + parseInt(dayC) + "天前";
  } else if (hourC >= 1) {
    result = "" + parseInt(hourC) + "小时前";
  } else if (minC >= 1) {
    result = "" + parseInt(minC) + "分钟前";
  } else
    result = "刚刚";
  return result;
}


// WEBPACK FOOTER //
// ./src/common/js/time.js